module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_popup_close-5feb6115d48ee952ad85328b7bb28bfd.svg";